export const vehicleTypeOptions = [
    'Truck',
    'Trailer',
    'Tanker',
    'Pickup',
    'Bus',
    'Minivan',
    'Small Car',
    'Other Vehicle',
    'JCB',
    'Poclain',
    'Crane',
    'Earth Movers',
    'Other Machine',
];

export const makeOptions = [
    'Tata',
    'Ashok Leyland',
    'Eicher',
    'Mahindra',
    'Bharat Benz',
    'Volvo',
    'Scania',
    'Maruti',
    'Hyundai',
    'Hitachi',
    'Mitsubishi',
    'Other',
];